<template>
  <!-- 数字滚动组件 -->
  <div class="counter">{{ count }}</div>
</template>
<script>
export default {
  props: ['targetNumber'],
  data() {
    return {
      duration: 3000,
      startTime: null,
      count: 0
    }
  },
  mounted() {

  },
  methods: {
    init() {
      requestAnimationFrame(this.step);
    },
    step(timestamp) {
      if (!this.startTime) this.startTime = timestamp; // 记录动画开始时间
      const progress = timestamp - this.startTime; // 计算动画进度
      // 根据动画进度计算当前数字的值
      this.count = Math.round(this.targetNumber * (progress / this.duration));// 更新数字显示
      if (progress < this.duration) {
        // 继续下一帧动画
        requestAnimationFrame(this.step);
      } else {
        // 动画结束，显示最终数字
        this.count = this.targetNumber;
      }
    }
  }
}
</script>
<style lang='less' rel='stylesheet/less'>
@rem: 16rem;
.counter {
  font-size: 24/@rem;
  font-weight: bold;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/rollNumber.vue